import { useEffect, useState } from "react";
import { useMediaQuery } from "@material-ui/core";

import {
  deleteStudent,
  defaultStudent,
  getStudent,
  getStudents,
  studentBulk,
  checkStateBulk,
  validateStudentBulkFetch,
  generatePresignedUrl,
} from "../../../../crud/api/students.crud";
import useTeams from "./useTeams";
import notice from "../../../../utils/notice";
import { getColumns, getOptions } from "../utils/Students.constants";
import { useStudent } from "./useStudent.hook";

const useMaintenance = ({
  is_admin,
  staff_member_admin,
  studentActions,
  settingLoader,
  setAlert,
  school,
  students,
}) => {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const { getTeams } = useTeams({});

  const openDialog = (mode, id = null) => {
    switch (mode) {
      case "create":
        settingLoader(true);
        studentActions.setStudent(defaultStudent);
        setDialog(mode);
        break;
      case "editing":
        settingLoader(true);
        getStudent(studentActions.setStudent, id)
          .then(() => setDialog(mode))
          .catch((err) => {
            console.error(err);
            settingLoader(false);
          });
        break;
      case "close":
        setDialog(mode);
        setTimeout(() => {
          studentActions.setStudent(defaultStudent);
        }, 500);
        break;
      default:
        console.error("Invalid dialog mode");
    }
  };

  const deleteStudents = (id) => {
    setAlert({
      title: "Delete Athlete",
      message: "Are you sure to permanently delete this Athlete?",
      btn_msg: "Delete Athlete",
      action: () => deleteStudent(studentActions.deleteStudents, id),
    });
  };

  const getQueryGroup = () => {
    if (group) {
      if (group && group !== null) {
        return "&team=" + group;
      }
    }
    return "";
  };

  const columns = getColumns({
    is_admin,
    openDialog,
    staff_member_admin,
    deleteStudents,
  });

  const [isGrid, setIsGrid] = useState(false);
  const [dialog, setDialog] = useState("close");
  const [email, setEmail] = useState("");
  const [query, setQuery] = useState("");
  const [group, setGroup] = useState("");
  const [bulk, setBulk] = useState(null);
  const [stepsBulk, setStepsBulk] = useState(1);
  const [bulkModal, setBulkModal] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [urlFile, setUrlFile] = useState("");
  const [errorsBulk, setErrorsBulk] = useState([]);
  const [teams, setTeams] = useState([]);
  const [rowsSelected, setRowsSelected] = useState([]);

  const { deleteStudentBulk } = useStudent({});

  const options = getOptions({
    isDesktop,
    settingLoader,
    students,
    studentActions,
    school,
    query,
    getQueryGroup,
    setRowsSelected,
  });

  const clearExistingInterval = () => {
    const existingId = parseInt(localStorage.getItem("idInterval"), 10);
    if (!isNaN(existingId)) {
      clearInterval(existingId);
      localStorage.removeItem("idInterval");
    }
  };

  const createStudentBulk = (values) => {
    setBulkLoading(true);
    if (!school?.slug) {
      setBulkLoading(false);
      notice("Please select a school");
    } else if (!bulk) {
      setBulkLoading(false);
      notice("Please add a csv file");
    } else
      studentBulk(school.slug, urlFile, values.team_id)
        .then((response) => {
          clearExistingInterval();
          const intervalIdentifierC = setInterval(async () => {
            try {
              await _checkStateBulk(response.id, 6, 6.1);
            } catch (e) {
              clearExistingInterval();
              setBulkLoading(false);
              notice("Error checking bulk upload status");
              console.error(e);
            }
          }, 5000);
          localStorage.setItem("idInterval", intervalIdentifierC);

          setBulk(null);
          setStepsBulk(4);
          setTimeout(() => {
            setBulkLoading(true);
            setStepsBulk(5);
          }, 2000);
        })
        .catch((e) => {
          setBulkLoading(false);
          notice("Error starting bulk upload");
          console.error(e);
        });
  };

  const _checkStateBulk = async (id_background, nextStep, stepError) => {
    const res = await checkStateBulk(id_background);
    if (res.state === "success") {
      clearExistingInterval();
      setStepsBulk(nextStep);
      setBulkLoading(false);
    }

    if (res.state === "error") {
      setErrorsBulk(res.result.errors);
      clearExistingInterval();
      setStepsBulk(stepError);
      setBulkLoading(false);
    }
  };

  const onFinish = async () => {
    setStepsBulk(1);
    setBulkModal(false);
    try {
      await getStudents(
        studentActions.setStudents,
        school.slug,
        1,
        query,
        getQueryGroup()
      );
    } catch (err) {
      console.error(err);
      notice("Error loading athletes");
    }
  };

  const validateStudentBulk = async (values) => {
    setBulkLoading(true);
    if (!school?.slug) {
      setBulkLoading(false);
      notice("Please select a school");
    } else if (!bulk) {
      setBulkLoading(false);
      notice("Please add a csv file");
    } else {
      setStepsBulk(2);
      let result;
      try {
        result = await uPloadFiletoS3();
      } catch (err) {
        console.error("Error uploading file:", err);
        setBulkLoading(false);
        setStepsBulk(2.1);
        notice("Error uploading file");
        return;
      }
      if (result === false) {
        return;
      }
      setUrlFile(result);
      validateStudentBulkFetch(school.slug, result)
        .then((response) => {
          clearExistingInterval();
          const intervalIdentifierC = setInterval(async () => {
            try {
              await _checkStateBulk(response.id, 3, 2.2);
            } catch (e) {
              clearExistingInterval();
              setBulkLoading(false);
              notice("Error checking bulk validation status");
              console.error(e);
            }
          }, 5000);
          localStorage.setItem("idInterval", intervalIdentifierC);
        })
        .catch(() => {
          setStepsBulk(2.2);
          setBulkLoading(false);
        });
    }
  };

  const uPloadFiletoS3 = async () => {
    const responseUploadUrl = await generatePresignedUrl(bulk.name);

    var res = await fetch(responseUploadUrl.uploadUrl, {
      method: "PUT",
      body: bulk,
    })
      .then((res) => res)
      .catch((error) => {
        setBulkLoading(false);
        setStepsBulk(2.1);

        return false;
      })
      .then((response) => response);

    if (!res || !res.ok) {
      setBulkLoading(false);
      setStepsBulk(2.1);
      return false;
    }

    return responseUploadUrl.key;
  };

  const onDeleteBulk = async () => {
    const payload = { ids: rowsSelected };
    try {
      await deleteStudentBulk(payload);
      await getStudents(
        studentActions.setStudents,
        school.slug,
        1,
        query,
        getQueryGroup()
      );
    } catch (err) {
      console.error("Error deleting athletes in bulk:", err);
      notice("Error deleting athletes");
    }
  };

  const isVisibleDeleteStudentBulkSButton = rowsSelected.length > 0;

  useEffect(() => {
    if (school && school !== null && school.slug && school.slug !== null) {
      if (teams.length === 0) {
        getTeams(setTeams, school.slug).catch((err) => {
          console.error("Error loading teams:", err);
        });
      }
      const loadStudents = async () => {
        try {
          if (query && query.length > 1)
            await getStudents(
              studentActions.setStudents,
              school.slug,
              1,
              query,
              getQueryGroup()
            );
          else
            await getStudents(
              studentActions.setStudents,
              school.slug,
              1,
              "",
              getQueryGroup()
            );
        } catch (err) {
          console.error("Error loading students:", err);
        }
      };
      loadStudents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, school, studentActions.setStudents, group]);

  useEffect(() => {
    return () => clearExistingInterval();
  }, []);

  return {
    columns,
    options,
    openDialog,
    deleteStudents,
    createStudentBulk,
    onFinish,
    validateStudentBulk,
    isGrid,
    setIsGrid,
    email,
    setEmail,
    query,
    setQuery,
    group,
    setGroup,
    bulk,
    setBulk,
    stepsBulk,
    setStepsBulk,
    setBulkLoading,
    setBulkModal,
    errorsBulk,
    teams,
    bulkLoading,
    dialog,
    bulkModal,
    onDeleteBulk,
    isVisibleDeleteStudentBulkSButton,
  };
};

export default useMaintenance;
